
import { LoaderIcon } from 'vue-feather-icons'
import { loadBirdEatsBird } from '~/fc/BirdEatsBird'
export default {
    components: { LoaderIcon },
    computed: {
        showWidget() {return this.$route.query.feedback && this.$route.query.feedback === 'true'} 
    },
    mounted () {
        if (process.client) loadBirdEatsBird()
    },
    methods: {
        startLoader () {
            document.getElementById('beb-trigger').classList.add('loading')
        }
    }
}
